var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayCloudSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5E4C00",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,1a1,1,0,0,1,1,1V3a1,1,0,0,1-2,0V2A1,1,0,0,1,13,1ZM6.636,6.05A1,1,0,0,0,8.05,4.636l-.707-.707A1,1,0,0,0,5.929,5.343ZM22,10H21a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2ZM18.657,3.929l-.707.707A1,1,0,1,0,19.364,6.05l.707-.707a1,1,0,0,0-1.414-1.414Zm2.586,9.828A5.963,5.963,0,0,1,23,18a5.006,5.006,0,0,1-5,5H8.729A7.737,7.737,0,0,1,1,15.271,7.212,7.212,0,0,1,7.706,8.006c.035,0,.069,0,.1,0A5.992,5.992,0,0,1,19,11a5.876,5.876,0,0,1-.147,1.294A5.979,5.979,0,0,1,21.243,13.757ZM10.042,8.31a6.91,6.91,0,0,1,4.5,4.214A5.73,5.73,0,0,1,16.867,12,3.824,3.824,0,0,0,17,11a4,4,0,0,0-6.958-2.69ZM21,18a4.055,4.055,0,0,0-3.965-4,3.812,3.812,0,0,0-2.493.868,1,1,0,0,1-1.607-.634l0-.016a5.044,5.044,0,0,0-.214-.857C10.9,8.071,3,9.324,3,15.271A5.735,5.735,0,0,0,8.729,21H18A3,3,0,0,0,21,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayCloudSvgrepoCom);
export default __webpack_public_path__ + "static/media/day-cloud-svgrepo-com.607ed61c389bc91a5912f5f42793d5d4.svg";
export { ForwardRef as ReactComponent };